<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    fill="#ffffff"
    d="M234.672 106.68v216.973l-70.25-70.25-30.167 30.167 121.75 121.75 121.74-121.75-30.167-30.167-70.24 70.247V106.68z"
  />
</svg>
